import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ConfirmacaoModalService } from '../../shared/services/confirmacao-modal.service';

/** Contrato dos componentes protegidos pelo `alteracoesNaoSalvasGuard`. */
export interface ComAlteracoesNaoSalvas {
  /** `true` quando existem alterações ainda não persistidas. */
  readonly houveAlteracao: boolean;
  /**
   * Texto da confirmação, quando a tela tem mensagem própria no requisito (ex.: MS024 da
   * HU104). Sem ele, vale o texto padrão abaixo.
   */
  readonly mensagemSaida?: string;
}

const MENSAGEM_PADRAO =
  'Há alterações não salvas neste registro. Se sair sem salvar, as alterações serão perdidas.';

/**
 * Impede sair da tela com alterações não salvas sem confirmação. Cobre qualquer
 * saída pelo Router (menu, breadcrumb, botão voltar do navegador, links internos).
 * O componente decide o que conta como alteração via `houveAlteracao`.
 */
export const alteracoesNaoSalvasGuard: CanDeactivateFn<ComAlteracoesNaoSalvas> = (component) => {
  if (!component?.houveAlteracao) return true;

  // PGPP-443: "Continuar editando" é a ação primária (direita) e "Sair sem salvar" a
  // secundária (esquerda). Confirmar = permanecer na tela; por isso o booleano é invertido.
  return inject(ConfirmacaoModalService)
    .confirmarAsync(
      'Atenção!',
      component.mensagemSaida ?? MENSAGEM_PADRAO,
      'Continuar editando',
      'Sair sem salvar',
    )
    .then((continuarEditando) => !continuarEditando);
};
